import { render, staticRenderFns } from "./CartTableHeader.vue?vue&type=template&id=8f6a7d7c&scoped=true&"
import script from "./CartTableHeader.vue?vue&type=script&lang=js&"
export * from "./CartTableHeader.vue?vue&type=script&lang=js&"
import style0 from "../../styles/cart-table.css?vue&type=style&index=0&id=8f6a7d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a7d7c",
  null
  
)

export default component.exports